import React from 'react';
import clsx from 'clsx';

export type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const TONES: Record<BadgeTone, string> = {
  success: 'tw-bg-ds-success-bg tw-text-ds-success-text',
  warning: 'tw-bg-ds-warning-bg tw-text-ds-warning-text',
  danger: 'tw-bg-ds-danger-bg tw-text-ds-danger-text',
  info: 'tw-bg-ds-info-bg tw-text-ds-info-text',
  neutral: 'tw-bg-ds-neutral-bg tw-text-ds-neutral-text',
};

export const Badge = ({
  tone = 'neutral',
  children,
}: {
  tone?: BadgeTone;
  children: React.ReactNode;
}) => (
  <span
    className={clsx(
      'tw-font-poppins tw-text-[11px] tw-font-semibold tw-rounded-full tw-px-2.5 tw-py-[3px] tw-inline-block tw-whitespace-nowrap tw-tracking-[.02em]',
      TONES[tone]
    )}
  >
    {children}
  </span>
);
